export const getProcessedTemplateHtml = (
  templateHtml: string,
  variables: { key: string; value: string | null }[],
): string => {
  let updatedTemplate = templateHtml;
  variables.forEach(({ key, value }) => {
    const placeholders = [`%recipient.${key}%`, `-recipient.${key}-`];
    placeholders.forEach((placeholder) => {
      updatedTemplate = updatedTemplate.replaceAll(placeholder, value || "");
    });
  });

  return updatedTemplate;
};
